import { Box, Typography } from '@mui/material';
import { LoadingButton, Warning } from '@ankr.com/ui';
import { tHTML } from '@ankr.com/common';

import { USER_SETTINGS_INTL_ROOT } from 'domains/userSettings/screens/Settings/components/TwoFABlock/constants';

import { AuthCodeInput } from '../AuthCodeInput';
import { useTFAInputStyles } from './useTFAInputStyles';
import { useTFAInput } from './hooks/useTFAInput';

export interface TFAInputProps {
  buttonText: string;
  onConfirm: (value: string) => void;
  errorMessage?: string;
  onReset?: () => void;
  isLoading?: boolean;
}

export const TFAInput = ({
  buttonText,
  errorMessage,
  isLoading,
  onConfirm,
  onReset,
}: TFAInputProps) => {
  const { hasError, isCodeValid, onChange, onClick, onSubmit } = useTFAInput({
    errorMessage,
    onConfirm,
    onReset,
  });

  const { classes } = useTFAInputStyles();

  return (
    <Box>
      <Typography className={classes.description} variant="body1">
        {tHTML(`${USER_SETTINGS_INTL_ROOT}.enter-code-dialog.description`)}
      </Typography>
      <form onSubmit={onSubmit}>
        <input type="submit" hidden />
        <AuthCodeInput onChange={onChange} hasError={hasError} />
        {hasError && (
          <Box className={classes.message}>
            <Warning color="error" />
            <Typography
              className={classes.messageText}
              variant="body2"
              color="error"
            >
              {errorMessage}
            </Typography>
          </Box>
        )}
        <LoadingButton
          className={classes.button}
          disabled={!isCodeValid}
          fullWidth
          loading={isLoading}
          onClick={onClick}
          size="large"
        >
          {buttonText}
        </LoadingButton>
      </form>
    </Box>
  );
};
